import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-image-dialog',
  templateUrl: './image-dialog.component.html',
  styleUrls: ['./image-dialog.component.css']
})
export class ImageDialogComponent implements OnInit {
  constructor() { }
  ngOnInit() {
  }
}
